
import axios from "axios";
import { store } from "store";
import { OutputBaseProps } from "utils/types/API";
import { MenuItemProps } from ".";
import { loading, update } from "store/menu";

interface ApiMenuUpdateInputProps extends MenuItemProps {
}

type ApiMenuUpdateOutputProps = OutputBaseProps<{ item: MenuItemProps; }, ApiMenuUpdateInputProps>;

export const apiMenuUpdate = async (data: ApiMenuUpdateInputProps) => {
    store.dispatch(loading());
    const res = (await axios.put<ApiMenuUpdateOutputProps>("/api/menu/update", data))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(update({ data: res.data.item }));
    }
    return res;
};